module.exports = __webpack_public_path__ + "static/media/microbit-unplugged.8abc1e15.gif";